import './index.scss'
import {InfoIcon} from '../../../icons'
import Spinner from '../../core/spinner'
import {colors} from '../../../utils/colors'
import {useSelector} from 'react-redux'
import classNames from 'classnames'

const InfoLine = ({infoText}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('warning-box', {
            dark: isDarkMode
        })}>
            <span className="info-icon">
                <InfoIcon color={colors.colorBlue}/>
            </span>
            <span className="warning-text">
                <span>{infoText}</span>
                <Spinner/>
            </span>
        </div>
    )
}

export default InfoLine
